import React, { useMemo, useState } from 'react';
import { Popover, Input, List } from 'antd';
import { SearchOutlined } from '@mui/icons-material';
import styled from 'styled-components';
import { useAllBook } from 'store/books/selectors';
import { useResources } from 'store/resources/selectors';
import { filter, debounce, get, find, concat } from 'lodash';
import { TagFilled } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import { ebookConfigDinamic, generateUrlForNonEbook, getStoryUrl, isVideo } from 'utils/lib/ebookHelper';
import { useStory } from 'store/story/selectors';
import { BACK_TO_BOOK } from 'utils/config/reference';
import { useBookUnits } from 'store/booksUnits/selectors';
import { useCurrentOrgPermission, useOrgTimezone } from 'store/organizations/selectors';
import { useExams } from 'store/exams/selectors';
import { useCurrentClass, useCurrentClassBook } from 'store/classes/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useOneWayTeacherVideo } from 'store/1wayteachervideo/selectors';
import { connect } from 'react-redux';
import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';
import { isAfterTime, isBeforTime } from 'utils/methods/math';
import moment from 'moment-timezone';
import { useLoadQuizAndClassActivity } from 'store/loadClassActivityAndQuiz/selector';
import customSearchSvg from "../utils/assets/images/custom-search.svg";
const StyledListItem = styled(List.Item)`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: flex-start;
  &:hover {
    background-color: #f5f5f5;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: auto;
  margin-right: 16px;
  object-fit:  cover;
`;
const ImageContainer = styled.div`
  display: flex;
  flex: 1;
  align-item: center;
`;
const Container = styled.div`
  display: flex;
  flex: 1;
`;

const StyledDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 16px; 
  flex:6;
`;
const DescriptonText = styled.div`
  font-size: 14px;
`;
const Titletext = styled.div`
  font-size: 16px;
  font-weight: 500;
`;
const Tags = styled.div`
  font-size: 12px;
  font-weight: 300;
`;
const ListContainer = styled.div`
  max-height: 50vh;  
  overflow-y: auto;
  min-height: 25vh;
`;
const dummy = [
    {
        title: 'Example Title 1',
        description: 'Description of item 1',
        image: 'https://via.placeholder.com/50'
    },
    {
        title: 'Example Title 2',
        description: 'Description of item 2',
        image: 'https://via.placeholder.com/50'
    },
    // Add more items as needed
]
//function to check is text included with non case sensitive
const noAssignedMsg = "Not Assigned by Teacher"
function SearchComponent(
    {
        classActivities,
        classQuizzes
    }
) {
    const [visible, setVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const booksAllList = useAllBook();
    const resources = useResources();
    const [filteredItems, setFilteredItems] = useState([]);
    const location = useLocation();
  							  const navigate = useNavigate();
    const story = useStory()
    const bookUnits = useBookUnits();
    const orgPermissions = useCurrentOrgPermission()
    const [state, setState] = React.useState({
        open: false,
        message: ""
    });
    const exams = useExams();
    const examBooks = useMemo(()=>exams?exams.flatMap(entry => entry.exams.map(exam => Number(exam.bookId))):[],[exams])
    const currentClassBookList = useCurrentClassBook();
    const currentUser = useCurrentUser();
    const  onewayTeacherBook = useOneWayTeacherVideo() || [];
    const orgTimezone = useOrgTimezone()
    const onewayTeacherBookIds = useMemo(()=> {
        if(currentUser?.role === "student"){
            const studentBook =  onewayTeacherBook?.filter(book => book?.for_student) || [];
            return studentBook?.map(book => book.id) || [];
        }
        return onewayTeacherBook.map(book => book.id);
    } , [onewayTeacherBook])
    const [currentPage, setCurrentPage] = useState(1);
    const currentClass = useCurrentClass();
    const getHiddenBooks = get(currentClass,"hide_books",[]).map(data => data?.bookId) || [];
    const oneWayStoryId = useMemo(() => story?.map(ele => Number(ele?.bookId)).filter(ele => ele!== null || ele!== undefined || ele !== 0),[story]);
    const loaderQuizAndClass = useLoadQuizAndClassActivity();

    const bookMapping = {
        "1nformate": [41],
        "comunidad": [43],
        "balcónCultural": [33],
        "conectandome": [49],
        "ap": [70, 69, 71, 72, 73, 75, 78],
        "exams": examBooks,
        "1WAYTEACHER": onewayTeacherBookIds,
        "1WAYSTORY": oneWayStoryId
      };

      const handleClose = () => {
        setState({ open: false, message: "" });
    };
    const showMsg = (text) => {
        setState({ open: true, message: text });
    };

    const checkBookAssigned = () => {
      const nonAssignableBook =
        booksAllList.filter((p) => p.isNotAssignable === true) || [];
      let bookArray = [];

      Object.keys(bookMapping).forEach((key) => {
        if (orgPermissions[key]) {
          const matchingBooks =
            nonAssignableBook.filter((p) =>
              bookMapping[key].includes(Number(p.id))
            ) || [];
          bookArray = bookArray.concat(matchingBooks);
        }
      });
  

      const currentClassBook = booksAllList?.filter((element) =>currentClassBookList?.some(k=>k==element.id));
      
      bookArray = bookArray.concat(currentClassBook);

      if(currentUser?.role === "student"){
        return bookArray?.filter(p => !p?.onlyTeacher) || []
      }else{
        return bookArray;
      }
    };

    const onSearch = debounce((text) => {
        let textLower = text.toLowerCase().trimStart();
        textLower = textLower.trimStart();
        if (textLower?.length === 0) {
            setCurrentPage(1); // Reset pagination when no results
          }
        if (textLower.length === 0) {
            setFilteredItems([]);
            return;
        }
        const bookArray = checkBookAssigned();
        const items = bookArray.flatMap(book => {
            const { pages, description: title, id } = book;
             if(id && getHiddenBooks?.includes(id)){
                return;
            }
            
           

            const filteredPages = pages.filter(page => 
                page.description?.toLowerCase().includes(textLower) ||
                page.tags?.toLowerCase().includes(textLower) 
            );
    
            return filteredPages.map(page => ({
                title: `${title || ''} Pg.${page.NumberMasked || page.pageId || ''}`,
                description: page.description,
                image: page.resource,
                chapter: id,
                pageId: page.pageId,
                tags: page.tags,
                isEbook: true
            }));
        });
     // this is for resources - Oneway resource
     if(orgPermissions["1WAYRESOURCES"]) {
        resources.forEach(resource => {
            resource.videos.forEach(video => {
                if ([video.tags, video.displayName, resource.categories, video.description].some(text => 
                    text?.toLowerCase().includes(textLower))
                ) {
                    items.push({
                        title: `${resource.displayName || ''}-${video.displayName || ''}`,
                        description: video.description,
                        image: video.thumbnail,
                        chapter: video.id, 
                        pageId: video.id,
                        tags: video.tags,
                        isVideo: true
                    });
                }
            });
        });
     }
     if (orgPermissions["1WAYTEACHER"]) {
        onewayTeacherBook.forEach(element => {
          if ([element.tags, element.title, element.category].some(text => 
            text?.toLowerCase().includes(textLower))) {
            items.push({
              title: element.title,
              description: element.title,
              image: element.poster,
              chapter: element.id, 
              pageId: element.id,
              tags: element.tags
            });
          }
        });
      }
        
    
        setFilteredItems(items?.filter(item => item != null || item != undefined));
    }, 300); // Debounce time can be adjusted based on the actual use case
    
    const redirectToAssignmentVideo = (id) => {
        let url = `/video?id=${id}&quiz=null`
        navigate(url);
    }
    const generateUrl = (CHAPTER_ID, page) => {
            const storyUrl = getStoryUrl(story, CHAPTER_ID, page, null, null)
            const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
            const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
            const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
            const url = generateUrlForNonEbook(bookitem?.id, page, null, null, backToLabel, null, CHAPTER_ID)
            if (url && backToLabel) {
                return url;
            }
            else if (storyUrl) {
                return storyUrl;
            } else {
                return null;
            }
    }


    const  checkLevel = (pageId,data)  => {
        const numericPageId = parseInt(pageId, 10);
        
        for (const levelObj of data.levels) {
          const start = parseInt(levelObj.start, 10);
          const finish = parseInt(levelObj.finish, 10);
          
          if (numericPageId >= start && numericPageId <= finish) {
            return levelObj;
          }
        }
        
        return null; 
      }

      const filteDatarByBookId = (x,isAssessmentBook,chapter) =>isAssessmentBook && get(x,"data.bookId") ?get(x,"data.bookId") === chapter : get(x,"data.chapter") === chapter;

    const checkStudentSideValidation = (CHAPTER_ID, page,obj) => {
        if(orgPermissions["exams"] && currentUser?.role === "student" && examBooks.includes(Number(CHAPTER_ID))){
            let startDate = "";
            let endDate = "";
            exams.forEach(element => {
                element.exams.forEach(data => {
                    if(data.bookId == CHAPTER_ID){
                        startDate = data?.startDate
                        endDate = data?.endDate
                    }
                })
                
    
            })
            const activitiy = find(classActivities, k => get(k, "data.bookId") == CHAPTER_ID)
            const quiz = find(classQuizzes, k => get(k, "data.bookId") == CHAPTER_ID)
                if (!activitiy && !quiz) {
                    showMsg(noAssignedMsg)
                    return false;
                }
                else{
                    if (startDate !== "" && endDate !== "") {
                        if (isAfterTime(startDate, moment(), orgTimezone)) {
                            showMsg(` Available by ${moment(startDate).format("MM/DD/YYYY hh:mm A")}`)
                            return false;
                        } else if (isBeforTime(endDate, moment(), orgTimezone)) {
                            showMsg(` Exam is ended on ${moment(endDate).format("MM/DD/YYYY hh:mm A")}`)
                            return false;
                        } 
                    } else if (startDate) {
                        if (isAfterTime(startDate, moment(), orgTimezone)) {
                            showMsg(` Available by ${moment(startDate).format("MM/DD/YYYY hh:mm A")}`)
                            return false;
                        } 
                    } else if (endDate) {
                        if (isBeforTime(endDate, moment(), orgTimezone)) {
                            showMsg(` Exam is ended on ${moment(endDate).format("MM/DD/YYYY hh:mm A")}`)
                            return false;
                        }
                    }
                    else{
                        return true
                    }
                }
        }
        else if(orgPermissions["1WAYSTORY"] && currentUser?.role === "student" && oneWayStoryId.includes(Number(CHAPTER_ID))) {
            // page - lvel , bookid
            const currentStoryBook = story?.find(book => book.bookId == CHAPTER_ID);
            const getBookFromBookList = booksAllList?.find(book => book.id == CHAPTER_ID);
            const level = checkLevel(page,currentStoryBook);
            const data = ebookConfigDinamic(
                CHAPTER_ID,
                booksAllList
              );
              const content  = data?.content
              const dataContent =  content.slice(content.findIndex(k=>k.pageId == parseInt(level?.start, 10)),content.findIndex(k=>k.pageId ==parseInt(level?.finish, 10))+1 )
              
              const pageIds = dataContent?.map((ele) => ele?.pageId?.toString()) || [];
              const mainActivityAndClassQuiz = concat(classActivities, classQuizzes);

               if (mainActivityAndClassQuiz?.length > 0) {
                const bookChapter = filter(classActivities, (classActivity) => classActivity.data?.chapter == CHAPTER_ID);
                const bookQuiz = filter(classQuizzes ,x=> filteDatarByBookId(x,getBookFromBookList?.is_assessment_book,CHAPTER_ID));
                 const combineClassActivityAndQuiz = concat(
                  bookChapter,
                  bookQuiz
                );
                if (loaderQuizAndClass?.classActivity && loaderQuizAndClass?.classQuiz) {
                  const filterActivityAndQuiz = combineClassActivityAndQuiz?.filter(
                    (element) => {
                      if (pageIds?.includes(element?.data?.page)) {
                        return true;
                      }
                      setState({open: true, message: "Not Assigned By Teacher"})
                      return false;
                    }
                  );
                  if (filterActivityAndQuiz?.length > 0) {
                    return true;
                  }
                  setState({open: true, message: "Not Assigned By Teacher"})
                  return false;
                }
              }
        }
        else{
            return true;
        }
    }
    const redirectToBook = (chapter , page,item) => {
        const checkStudentValid = checkStudentSideValidation(chapter , page,item);
        if(!checkStudentValid) return;
        const generatedUrl = generateUrl(chapter,page) 
        if (isVideo(chapter, resources)) {
            redirectToAssignmentVideo(chapter);
        }
        else if (generatedUrl) {
            navigate(generatedUrl); 
        }
        else {
            navigate(`/ebook?chapter=${chapter}&page=${page}&activity=null&quiz=null`);
        }
    }

    const handleVisibleChange = visible => {
        setCurrentPage(1);
        clearData()
        setVisible(visible)
    };
    const onClick = (chapter, page,item) => {
        redirectToBook(chapter, page,item);
        setVisible(false)
        clearData()
    }
    const clearData = () => {
        setSearchTerm('')
        setFilteredItems([])
    }
    const content = (
        <div>
            <Input
                placeholder="Search..."
                value={searchTerm}
                autoFocus
                onChange={e => {
                    setSearchTerm(e.target.value);
                    onSearch(e.target.value)
                }}
                prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.45)' }} />}
                style={{ width: '100%', marginBottom: 10 }}
            />
            <ListContainer>
                <List
                    itemLayout="horizontal"
                    dataSource={filteredItems}
                    pagination={{
                        current: currentPage,
                        onChange: (page) => {
                            setCurrentPage(page);
                          },
                        pageSize: 15,
                        showSizeChanger: false
                    }}
                    renderItem={item => (
                        <StyledListItem onClick={() => onClick(item.chapter, item.pageId,item)}>
                            <Container>
                                <ImageContainer>
                                    <StyledImage alt={item.title} src={item.image} />
                                </ImageContainer>

                                <StyledDescription>
                                    <Titletext>{item.title}</Titletext>
                                    <DescriptonText>{item.description}</DescriptonText>
                                    {item.tags ? <Tags> <TagFilled className='iconFldChange' /> {item.tags}</Tags> : null}
                                </StyledDescription>
                            </Container>
                        </StyledListItem>
                    )}
                />
            </ListContainer>

        </div>
    );

    return (
        <div>
             <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={state.open}
                    autoHideDuration={3000}
                    onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error">
                        <strong>ALERT:</strong> {state.message}
                    </Alert>
                </Snackbar>
            <Popover
                content={content}
                title="Search"
                trigger="click"
                open={visible}
                onOpenChange={handleVisibleChange}
                placement="bottom"
                overlayClassName="searchdropdown"
                overlayStyle={{ width: '500px' }}
            >
               <img src={customSearchSvg} alt="" title="" />
            </Popover>
        </div>
    );
}



const mapStateToProps = state => ({
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
});

export default connect(mapStateToProps, null)(SearchComponent);
